import * as Yup from "yup";
import i18n from "i18next";

Yup.setLocale({
  mixed: {
    required: ({ label }) =>
      i18n.t("yup.mixed.required", { label: label?.toLowerCase() }),
    notType: ({ label }) => i18n.t("yup.mixed.notType", { label }),
  },
  string: {
    email: () => i18n.t("yup.string.email"),
    min: ({ label, min }) => i18n.t("yup.string.min", { label, min }),
    matches: ({ label }) => i18n.t("yup.string.matches", { label }),
  },
  number: {
    integer: ({ label }) => i18n.t("yup.number.integer", { label }),
    min: ({ label, min }) => i18n.t("yup.string.email", { label, min }),
  },
});
